"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function RequestADemo() {
  return <section id="request-a-demo" className="relative w-full py-12 md:py-20 bg-background overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: "linear-gradient(0deg, transparent 24%, rgba(0, 0, 0, 0.05) 25%, rgba(0, 0, 0, 0.05) 26%, transparent 27%, transparent 74%, rgba(0, 0, 0, 0.05) 75%, rgba(0, 0, 0, 0.05) 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, rgba(0, 0, 0, 0.05) 25%, rgba(0, 0, 0, 0.05) 26%, transparent 27%, transparent 74%, rgba(0, 0, 0, 0.05) 75%, rgba(0, 0, 0, 0.05) 76%, transparent 77%, transparent)",
      backgroundSize: "32px 32px"
    }} />

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          
          
        </div>

        <div className="flex justify-center items-center">
          <Link to="/BookDemoPage">
            <Button className="bg-accent hover:bg-accent/90 text-accent-foreground px-8 py-6 h-auto rounded-lg shadow-md font-bold text-lg transition-all hover:scale-105">
              Request Demo Now
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}